var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"platform-item d-flex ai-center jc-center"},[_c('img',{attrs:{"src":_vm.platform.logo}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.platform.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }